// extracted by mini-css-extract-plugin
module.exports = {"panel":"login__panel___2G5nX"};